import { render, staticRenderFns } from "./ToBeShippedZoneManage.vue?vue&type=template&id=e0ea5748&"
import script from "./ToBeShippedZoneManage.vue?vue&type=script&lang=js&"
export * from "./ToBeShippedZoneManage.vue?vue&type=script&lang=js&"
import style0 from "./ToBeShippedZoneManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ToBeShippedZoneManage.vue"
export default component.exports